export default {"src":"https://filecdn-other.xingyeai.com/xingye-ugc/_next/static/media/warn.ea856d3e.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};